import { render } from "./ObjectListFields.vue?vue&type=template&id=34135ac2&scoped=true"
import script from "./ObjectListFields.vue?vue&type=script&lang=js"
export * from "./ObjectListFields.vue?vue&type=script&lang=js"

import "./ObjectListFields.vue?vue&type=style&index=0&id=34135ac2&lang=scss"
import "./ObjectListFields.vue?vue&type=style&index=1&id=34135ac2&lang=scss&scoped=true"

import exportComponent from "/app/tmp/blackhall/V3/v2025.48.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34135ac2"]])

export default __exports__